"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RpcInterceptorSetBuilder = exports.RpcCall = void 0;
/**
 * An executable RpcCall.
 */
class RpcCall {
    request;
    constructor(request) {
        this.request = request;
    }
    /**
     * Convenience method for creating a wrapped instance of a call.
     */
    static async wrap(next, request, wrapper) {
        const original = await next(request);
        return new WrappedRpcCall(original, wrapper);
    }
}
exports.RpcCall = RpcCall;
class WrappedRpcCall extends RpcCall {
    delegate;
    wrapper;
    constructor(delegate, wrapper) {
        super(delegate.request);
        this.delegate = delegate;
        this.wrapper = wrapper;
    }
    async execute() {
        return this.wrapper(this.delegate);
    }
}
/**
 * Builds an `RpcInterceptorSet`.
 */
class RpcInterceptorSetBuilder {
    interceptors = [];
    lastInterceptors = [];
    /**
     * Adds an `interceptor` to the set.
     *
     * Interceptors are run in the order they are added. Argument is nullable to
     * make chaining conditional interceptors easier.
     */
    add(interceptor) {
        if (interceptor) {
            this.interceptors.push(interceptor);
        }
        return this;
    }
    /**
     * Adds all `interceptors` to the set.
     *
     * @see add
     */
    addAll(interceptors) {
        interceptors.forEach((interceptor) => this.add(interceptor));
        return this;
    }
    /**
     * Adds an `interceptor` to the `lastInterceptors` list.
     *
     * The `lastInterceptors` are run after all other interceptors in this set
     * as well as after any adhoc per-request interceptors run. Within the
     * `lastInterceptors` list, interceptors are run in the order they are
     * added. Argument is nullable to make chaining conditional interceptors
     * easier.
     */
    addLast(interceptor) {
        if (interceptor) {
            this.lastInterceptors.push(interceptor);
        }
        return this;
    }
    /**
     * Adds all `interceptors` to the `lastInterceptors` list.
     *
     * @see addLast
     */
    addAllLast(interceptors) {
        interceptors.forEach((interceptor) => this.addLast(interceptor));
        return this;
    }
    /**
     * Builds and returns the `RpcInterceptorSet`.
     */
    build() {
        return {
            interceptors: this.interceptors,
            lastInterceptors: this.lastInterceptors,
        };
    }
}
exports.RpcInterceptorSetBuilder = RpcInterceptorSetBuilder;
//# sourceMappingURL=RpcInterceptor.js.map